import React from "react";
import bottleOutlineImg from "../../../assets/images/wine/bottle-outline.svg";

import {
  Tags,
  TitleAndBookmarkContainer,
  WineCardContainer,
  WineCardFooter,
  WineCardPanelBottom,
  WineCardPanelLeft,
  WineCardPanelRight,
  WineImageHolder,
} from "../WineCard/style";
import {
  ButtonPlaceholder,
  ProductCardLoadingPreviewImg,
  ProductNamePlaceholder,
  ProductTagPlaceholder,
} from "./style";

interface ProductCardLoadingProps {
  isInCollections?: boolean;
}

const ProductCardLoading = ({ isInCollections = false }: ProductCardLoadingProps) => (
  <WineCardContainer isInCollections={isInCollections}>
    <WineImageHolder>
      <ProductCardLoadingPreviewImg src={bottleOutlineImg} alt={"Product image placeholder"} />
    </WineImageHolder>
    <WineCardFooter>
      <TitleAndBookmarkContainer>
        <ProductNamePlaceholder />
      </TitleAndBookmarkContainer>
      <Tags>
        <ProductTagPlaceholder width="120px" />
        <ProductTagPlaceholder width="40px" />
        <ProductTagPlaceholder width="110px" />
        <ProductTagPlaceholder width="130px" />
      </Tags>
      <WineCardPanelBottom>
        <WineCardPanelLeft />
        <WineCardPanelRight>
          <ButtonPlaceholder />
        </WineCardPanelRight>
      </WineCardPanelBottom>
    </WineCardFooter>
  </WineCardContainer>
);

export default ProductCardLoading;
